import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../../constants/common'
import {
  getBuildingProfilePathname,
  getFlatProfilePathname,
} from '../../../../../utils/link'
import { getUserAvatar, getUserProfileRoute } from '../../../../../utils/user'
import { getUserLabel } from '../../../../User'

import { COPIED_TO_TAG_LIST_ENTITY } from './CopiedToTagList.constants'

// #TODO add other entities for list
function toListItem(items, entity) {
  if (isCopyUserItem(entity)) {
    return toUserListItems(items)
  }
}

function toUserListItem(user = EMPTY_OBJECT) {
  return {
    ...user,
    avatarForTag: getUserAvatar(user),
    entity: COPIED_TO_TAG_LIST_ENTITY.User,
    name: getUserLabel(user),
  }
}

function toUserListItems(items = EMPTY_LIST) {
  return items.map(toUserListItem)
}

export function isCopyUserItem(entity) {
  return entity === COPIED_TO_TAG_LIST_ENTITY.User
}

export function isCopyBuildingItem(entity) {
  return entity === COPIED_TO_TAG_LIST_ENTITY.Building
}

export function isCopyFlatItem(entity) {
  return entity === COPIED_TO_TAG_LIST_ENTITY.Flat
}

export function getPreparedCopiedToTagItems(entities = EMPTY_OBJECT) {
  return Object.entries(entities).reduce(
    (acc, [entity, items]) => [...acc, ...toListItem(items, entity)],
    []
  )
}

export function copiedToFilterByName({ name }, search) {
  return name.toLowerCase().includes(search.toLowerCase())
}

export function getCopiedToTagItemProfileLink({
  availableSections,
  entity,
  id,
  isExternalContactProfileNGAvailable,
  isProviderProfileNGAvailable,
  isUserProfileNGAvailable,
  role,
}) {
  if (isCopyUserItem(entity)) {
    return getUserProfileRoute({
      id,
      isExternalContactProfileNGAvailable,
      isProviderProfileNGAvailable,
      isUserProfileNGAvailable,
      role,
    })
  }

  if (isCopyBuildingItem(entity)) {
    return getBuildingProfilePathname({ availableSections, id })
  }

  if (isCopyFlatItem(entity)) {
    return getFlatProfilePathname({ availableSections, id })
  }
}
